import logo from '../assets/Logo.png';
import { useUser } from '../context/useUser';
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../api/client';

const Header = () => {
  const { user, selectedCompany } = useUser();
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!user?.token || !selectedCompany?.summaryId) return;

    try {
      const data = await apiFetch(`/form/summary/${selectedCompany.summaryId}/count`, {
        token: user.token,
      });
      setCartCount(data.count || 0);
    } catch (err) {
      console.error("Failed to fetch cart count:", err);
      setCartCount(0);
    }
  }, [user?.token, selectedCompany?.summaryId]);

  useEffect(() => {
    if (!user?.token || !selectedCompany?.summaryId) return;

    fetchCount();
    window.addEventListener("cart-updated", fetchCount);
    return () => window.removeEventListener("cart-updated", fetchCount);
  }, [fetchCount, user?.token, selectedCompany?.summaryId]);


  const handleCartClick = () => {
    navigate("/cart");
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  const handleProfileClick = () => {
    navigate("/profile");
  };

  return (
    <header className="header-container">
      <div className="header-content">
        <div className="header-logo" onClick={handleLogoClick}>
          <img src={logo} alt="Logo" />
        </div>

        {user && user.token && (
          <div className="header-icons">
            <div className="cart-icon" onClick={handleCartClick}>
              <i className="fas fa-shopping-cart" />
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </div>
            <div className="cart-icon" onClick={handleProfileClick}>
              <i className="fas fa-user" />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
